<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo_white.png" alt="logo图">
    </div>
    <p class="title">广州零守科技有限责任公司</p>
    <p class="address_tel_fax">
      <span>地址：广州市天河区中山大道中433、435号六层603房B931</span>
      <span>Tel：19832897297</span>
    </p>
    <p class="email_wx">
      <span>邮箱：19832897297@139.com</span>
      <span>微信/手机：19832897297</span>
    </p>
    <p class="copy">Copyright &copy; 2025 - {{ new Date().getFullYear() }} 广州零守科技有限责任公司.粤ICP备2025423120号-1</p>
    <br/>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 67px;
  margin: 20px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 20px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue